import * as React from "react";
import { EmailDetailsStore } from "Pages/Project/Communication/Stores/EmailDetailsStore";
import { Empty } from "antd";
import { EmailDetailsBody } from "Pages/Project/Communication/Components/EmailDetailsBody";
import { observer } from "mobx-react";
import { Spin } from "Components/General/Spin";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";

interface EmailDetailsModalProps extends ModalComponentProps {
  emailId: string;
}

export const EmailDetailsModal = observer(
  class EmailDetailsModal extends React.Component<EmailDetailsModalProps> {
    emailDetailsStore: EmailDetailsStore;
    constructor(props: EmailDetailsModalProps) {
      super(props);
      this.emailDetailsStore = new EmailDetailsStore();
    }

    componentDidMount() {
      if (this.props.emailId) {
        this.init();
      }
    }

    init = () =>
      this.emailDetailsStore.init({ emailType: "SENT", emailId: this.props.emailId, projectSpecific: false });

    render() {
      return (
        <>
          {/* Suggesting that email will always have a subject */}
          {this.emailDetailsStore.data.subject ? (
            <Spin spinning={this.emailDetailsStore.state === "LOADING"}>
              <EmailDetailsBody
                id={this.emailDetailsStore.data.id}
                type={this.emailDetailsStore.data.type}
                projectSpecific={this.emailDetailsStore.data.projectSpecific}
                to={this.emailDetailsStore.data.to}
                from={this.emailDetailsStore.data.from}
                cc={this.emailDetailsStore.data.cc}
                bcc={this.emailDetailsStore.data.bcc}
                subject={this.emailDetailsStore.data.subject}
                timestamp={+this.emailDetailsStore.data.timestamp}
                body={this.emailDetailsStore.data.body}
                attachments={this.emailDetailsStore.data.attachments}
                abstractRecipients={this.emailDetailsStore.data.abstractRecipients}
                moveAttachToProject={this.emailDetailsStore.moveAttachToProject}
                correspondents={this.emailDetailsStore.data.correspondents}
              />
            </Spin>
          ) : (
            <Empty />
          )}
        </>
      );
    }
  }
);
